import { render } from "./Todo.vue?vue&type=template&id=6bf99e97&scoped=true"
import script from "./Todo.vue?vue&type=script&lang=ts"
export * from "./Todo.vue?vue&type=script&lang=ts"

import "./Todo.vue?vue&type=style&index=0&id=6bf99e97&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6bf99e97"

export default script